import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";
import { ReactSVG } from "react-svg";
import { SortableItemProps } from "./types";


const SortableItem: React.FC<SortableItemProps> = ({ id, children }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            {...attributes}
            className="relative"
        >
            {/* drag handle */}
            <span
                {...listeners}
                className=" absolute left-2 top-1/2 -translate-y-1/2 cursor-grab text-slate-400"
            >
                <ReactSVG src="/media/icons/sort-icon.svg" className="w-4 h-4 stroke-[#667085]" />
            </span>

            <div className="pl-8">{children}</div>
        </div>
    );
};

export default SortableItem;
